/**
 * The channel new awards travel on from the API layer to the UI. The server
 * returns them on any write in the X-New-Awards header; useApi reads it on
 * every response and calls emitNewAwards, and AwardCelebrations (mounted once
 * in RootLayout) listens to show the unlock toast. A plain module rather than
 * React state, since useApi isn't tied to any one component.
 */
const listeners = new Set();

export const AWARDS_HEADER = "x-new-awards"; // axios lowercases header names

/** Subscribe to new awards; returns the unsubscribe function. */
export function onNewAwards(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Hands awards to every listener. */
export function emitNewAwards(awards) {
  listeners.forEach((listener) => listener(awards));
}

/** Reads an API response's new awards, if any, and hands them to listeners. */
export function emitAwardsFromResponse(response) {
  const raw = response?.headers?.[AWARDS_HEADER];
  if (!raw) return;
  let awards;
  try {
    awards = JSON.parse(raw);
  } catch {
    return;
  }
  if (Array.isArray(awards) && awards.length) emitNewAwards(awards);
}
